import { postQuery } from "../api";

/**
 * Subscribes a user to email or SMS notifications for garbage day reminders.
 *
 * @async
 * @function
 * @param {'email'|'text'} type - The type of subscription, either 'email' or 'sms'.
 * @param {string} userInfo - The user's email address (if type is 'email') or phone number (if type is 'sms').
 * @param {string} garbageDay - The day of the week for garbage collection.
 * @returns {Promise<any>} The response from the subscription API.
 * @throws Will throw an error if the API request fails.
 */
export const subscribeEmailOrSms = async (type, emailOrPhone, garbageDay) => {
  const url = type === "email" ? process.env.REACT_APP_SUBSCRIBE_EMAIL_URL : process.env.REACT_APP_SUBSCRIBE_SMS_URL;
  const body = type === "email" ? { email: emailOrPhone, garbageDay } : { destinationNumber: emailOrPhone, garbageDay };

  try {
    const response = await postQuery(url, body);
    return response;
  } catch (error) {
    throw error;
  }
};
